// hooks/useWarning.ts
import { message } from "antd";

export const useMessage = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const showSuccess = (texto: string | undefined) => {
    messageApi.open({
      type: "success",
      content: texto,
      key: "success",
    });
  };

  const showError = (texto: string | undefined | null) => {
    messageApi.open({
      type: "error",
      content: texto,
      key: "error",
    });
  };

  const showErrorLong = (texto: string | undefined | null) => {
    messageApi.open({
      type: "error",
      content: texto,
      key: "error",
      duration: 8,
    });
  };

  const showWarning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
      key: "warning",
      duration: 5,
    });
  };

  return { showSuccess, showError, showWarning, contextHolder };
};
